export default __webpack_public_path__ + "static/media/logo.a2512c0f.svg";